// Module
var code = `<div class="model-confusion-container">
  <div ng-repeat="cell in \$ctrl.confusionMatrixCells"
       class="{{cell.backgroundColorSelector}} {{cell.gridAreaSelector}}">
    <div class="center">
      <div>{{cell.fieldName}}</div>
      <div class="prediction-value" ng-if="\$ctrl.confusionMatrixValues[cell.fieldValueKey]">
        {{\$ctrl.confusionMatrixValues[cell.fieldValueKey]}}
      </div>
    </div>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal-confusion-matrix.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;